import React from 'react';
import Logo from '../../assets/images/MyPath@2x.png';

import Hamburger from '../Hamburger/Hamburger';
import MenuLinks from '../MenuLinks/MenuLinks';
import './HeaderNav.scss';

const HeaderNav = ({ position, setPosition }) => (
  <div id="HeaderNav">
    <div className="menu-row">
      <Hamburger setPosition={setPosition} />

      <div className="title">
        <img src={Logo} alt="My Path" />
      </div>


      <div className="menu desktop-tablet-only">
        <MenuLinks setPosition={setPosition} />
        <hr className={position} />
      </div>
    </div>
  </div>
);

export default HeaderNav;
